<div class="container-fluid">
  <div class="row mb-3">
    <div class="col-md-12 text-right">
      <button class="btn btn-primary btn-sm" (click)="abrirModalNovaConta()">
        <i class="fa fa-plus"></i> Nova Conta
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="contasAgrupadas.length === 0" class="alert alert-info text-center mt-3">
        Não há contas a pagar cadastradas
      </div>
      <div *ngFor="let grupo of contasAgrupadas" class="card mt-3">
        <div class="card-header bg-light">
          <h3 class="card-title text-capitalize"><strong>{{ grupo.mes }}</strong></h3>
          <div class="card-tools">
            <span class="badge badge-danger">Total: {{ grupo.total | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
        </div>
        <div class="card-body p-0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Vencimento</th>
                <th>Pagamento</th>
                <th class="text-right">Valor</th>
                <th class="text-center" style="width: 150px">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let conta of grupo.contas">
                <td>{{ conta.descricao }}</td>
                <td>{{ conta.dataVencimento | date:'dd/MM/yyyy' }}</td>
                <td>{{ conta.pago ? (conta.dataPagamento | date:'dd/MM/yyyy') : '' }}</td>
                <td class="text-right">{{ conta.valor | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">
                  <div class="btn-group">
                    <button *ngIf="conta.pago" class="btn btn-xs btn-info" title="Visualizar" (click)="alterarConta(conta)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button *ngIf="!conta.pago" class="btn btn-xs btn-success" title="Pagar" (click)="pagarConta(conta)">
                      <i class="fa fa-check"></i>
                    </button>
                    <button *ngIf="!conta.pago" class="btn btn-xs btn-primary" title="Alterar" (click)="alterarConta(conta)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button *ngIf="!conta.pago" class="btn btn-xs btn-danger" title="Deletar" (click)="deletarConta(conta)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-financeiro-modal-conta
  *ngIf="modalNovaConta"
  [novaConta]="novaConta"
  [pessoas]="pessoas"
  (fechar)="fecharModal()"
  (salvar)="salvarConta()"
></app-financeiro-modal-conta>

<app-financeiro-modal-pagamento
  *ngIf="modalPagarConta"
  [pagamento]="pagamento"
  (fechar)="fecharModal()"
  (confirmar)="confirmarPagamento()"
></app-financeiro-modal-pagamento>

<app-financeiro-modal-deletar
  *ngIf="modalDeletarConta"
  [contaParaDeletar]="contaParaDeletar"
  (fechar)="fecharModal()"
  (confirmar)="confirmarDelecao()"
></app-financeiro-modal-deletar>
